import { Form, Text, NestedField, Checkbox, Field } from 'react-form';
import { AbconetApi } from '../General/AbconetApi';


export class UserEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isSaved: true,
            errorMessage: "",
            isSaving: false
        }
    }

    sendStateToServer() {
        var self = this;

        AbconetApi.post('/api/user/profileupdate', this.state.submittedValues).then(response => {
            setTimeout(() => {
                self.setState({ isSaved: true, errorMessage: "", isSaving: false });
            }, 1000);

        });
    }

    submitUser(submittedValues) {

        console.log('submittedValues', submittedValues)
        this.setState({ submittedValues, isSaving: true }, this.sendStateToServer);
    }

    showErrorMessage() {
        if (this.state.errorMessage != null && this.state.errorMessage.length > 0) {
            return (
                <div className="alert alert-danger" role="alert">
                    {this.state.errorMessage}
                </div>
            );
        }
        return null;
    }


    renderSaveButton() {
        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }
        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }

        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSaved || this.state.isSaving}>{btnText}</button>;
    }


    setChange(data) {
        this.setState({ isSaved: false });
    }

    renderEmailField() {
        if (this.props.initialState.id < 0) {
            return <div>
                <h5>
                    <label className="mb-0" htmlFor="dynamic-template-name">Email:</label>
                </h5>
                <Text field="email" id="dynamic-template-name" className="form-control" />
            </div>;
        }

        return null;
    }

    render() {

        return (
            <div>
                {this.showErrorMessage()}
                {this.props.initialState.id < 0 ? <h2>Create User</h2> : <h2>Edit User</h2>}
              
                <Form
                    onChange={this.setChange.bind(this)}
                    onSubmit={this.submitUser.bind(this)} defaultValues={this.props.initialState}>
                    {formApi => {
                        this.formApi = formApi;

                        return (
                            <form onSubmit={formApi.submitForm} id="group-edit-form">
                                <div>
                                    <div>
                                        <h5>
                                            <label className="mb-0" htmlFor="dynamic-template-name">First Name:</label>
                                        </h5>
                                        <Text field="firstName" id="dynamic-template-name" className="form-control" />
                                    </div>
                                    <div>
                                        <h5>
                                            <label className="mb-0" htmlFor="dynamic-template-name">Last Name:</label>
                                        </h5>
                                        <Text field="lastName" id="dynamic-template-name" className="form-control" />
                                    </div>

                                    {this.renderEmailField()}

                                </div>
                                <br />

                                <a href="/users" className="btn btn-outline-primary">View all users</a>
                                {this.renderSaveButton()}
                            </form>
                        )
                    }}
                </Form>
            </div>
        );
    }

}